import fetch from "cross-fetch";
import { CaptureStepTypes } from "@enums/capture-step-types";
import { CaptureStep } from "@idw-types/data/capture-step";
import { QueryParametersState } from "@idw-types/state";

export const submitCaptures = (
    queryParameters: QueryParametersState,
    responseToken: string,
    captureSteps: Array<CaptureStep>,
    asi: string
) => {
    const stepPostData: Array<{ id: number; type: CaptureStepTypes; data: string; }> = captureSteps.filter(captureStep => captureStep.completed).map(captureStep => {
        return {
            id: captureStep.id,
            type: captureStep.type,
            data: captureStep.data
        };
    });

    const body = {
        token: responseToken,
        steps: stepPostData,
        asi
    };

    const route = `${queryParameters.apiUrl}/axn/doc/submit`;
    const request = {
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body),
        method: "POST"
    };

    return fetch(route, request);
};